import { ActionTypes } from '../actions/types';

const initialState = {
  laender: [],
  suchvorschlaege: [],
};

export default function (
  state = initialState,
  action: { type: ActionTypes; payload?: any }
) {
  const { type, payload } = action;

  switch (type) {
    case ActionTypes.GET_LAENDER_REG: {
      payload.push('');
      payload?.sort((a: string, b: string) => {
        const textA = a.toUpperCase();
        const textB = b.toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });
      return {
        ...state,
        laender: payload,
      };
    }
    case ActionTypes.GET_ORTE_REG: {
      return {
        ...state,
        suchvorschlaege: payload,
      };
    }
    case ActionTypes.CLEAR_SUCHVORSCHLAEGE:
      return {
        ...state,
        suchvorschlaege: [],
      };
    default:
      return state;
  }
}
